import { Center, CircularProgress, Stack } from '@eigtech/ui-shared-dave'
import { MeetingStatus } from 'amazon-chime-sdk-component-library-react'
import { useChimeMeeting, UseChimeMeetingProps } from '../hooks/useChimeMeeting'
import { useRememberCameraSelection } from '../hooks/useRememberCameraSelection'
import { DevicesControls } from './Controls/DevicesControls'
import { MeetingControls } from './Controls/MeetingControls/MeetingControls'
import { ActiveVideo } from './Video/ActiveVideo'
import { RosterVideos } from './Video/RosterVideos'

export type ChimeMeetingProps = UseChimeMeetingProps

export function ChimeMeeting(props: ChimeMeetingProps) {
  const { isPending, meetingDetails, meetingStatus } = useChimeMeeting(props)
  const meetingEnded = meetingStatus === MeetingStatus.Ended

  if (!meetingDetails) return null

  if (isPending) {
    return (
      <Center py="12">
        <CircularProgress isIndeterminate size="100" />
      </Center>
    )
  }

  return (
    <>
      <Stack direction="column" display={{ base: 'block', lg: 'none' }} gap="4" spacing="4">
        {!meetingEnded && <ActiveVideo pb="3" w="full" />}
        <Stack
          alignItems="flex-start"
          direction={{ base: 'column-reverse', lg: 'row' }}
          pb="3"
          w="full"
        >
          <MeetingControls w="full" />
          {!meetingEnded && <RosterVideos />}
        </Stack>
        <DevicesControls />
      </Stack>

      <Stack
        alignItems="flex-start"
        direction={{ base: 'column-reverse', lg: 'row' }}
        display={{ base: 'none', lg: 'flex' }}
        gap="4"
      >
        <Stack maxW={{ base: 'full', lg: meetingEnded ? 'full' : '60' }} w="full">
          <MeetingControls w="full" />

          <DevicesControls />
        </Stack>

        {!meetingEnded && (
          <Stack direction={{ base: 'column-reverse', lg: 'column' }} w="full">
            <RosterVideos />
            <ActiveVideo flexGrow={1} />
          </Stack>
        )}
      </Stack>

      {!meetingEnded && <RememberCamera />}
    </>
  )
}

function RememberCamera() {
  useRememberCameraSelection()
  return null
}
